const { useEffect } = require('react');
const { useMap } = require('react-leaflet');

const OnMapReady = () => {
  const map = useMap();

  useEffect(() => {
    setTimeout(() => {
      map.invalidateSize?.();
    }, 250);
  }, [map]);

  return null;
};

export default OnMapReady;
